(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-bsb-ib-end-date]').forEach(updateCountdown);
  }

  function updateCountdown(el) {
    const end = new Date(el.dataset.bsbIbEndDate + 'T00:00:00');
    if (isNaN(end.getTime())) return;

    const now = new Date();
    const nowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const msPerDay = 24 * 60 * 60 * 1000;
    const daysLeft = Math.max(0, Math.ceil((end - nowMidnight) / msPerDay));
    const daysLabel = daysLeft === 0 ? 'Last day' : daysLeft + ' days';

    el.textContent = el.textContent.replace('{days}', daysLabel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
